import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import RateSettingsShow from '../shared/rate-settings-show/RateSettingsShow';

const AgencyLocationRateSettingShow = () => (
  <Show>
    <RateSettingsShow />
  </Show>
);

AgencyLocationRateSettingShow.query = gql`
  query agencyLocationRateSetting($id: Int!) {
    agencyLocationRateSetting(id: $id, include_parents: true) {
      id
      active
      agency_id
      agency {
        id
        name
      }
      location_id
      location {
        id
        name
      }
      settings
      agency_location_rate_setting
      location {
        primary_billing_group {
          plan
        }
      }
      updated_at
    }
  }
`;

export default AgencyLocationRateSettingShow;
